var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',[_vm._v("Help")]),_c('p',[_vm._v(" Zoek je hulp bij de app? Kijk in het menu onder 'help & contact' ")])])}
var staticRenderFns = []

export { render, staticRenderFns }